"use client";

import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";
import { ReactNode } from "react";

interface SessionProviderProps {
  children: ReactNode;
}

export function SessionProvider({ children }: SessionProviderProps) {
  return (
    <NextAuthSessionProvider
      // Silently refresh the JWT every 10 minutes to prevent expiry.
      // The JWT maxAge is 8 hours — this keeps it alive during active use.
      refetchInterval={10 * 60}
      // Disabled — the background poll is sufficient and focus events create
      // noisy duplicate requests on every tab switch.
      refetchOnWindowFocus={false}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
